/**
 * Powód odmowy zapisu, który baza podaje słowami dla człowieka.
 *
 * Wyzwalacze ochrony kartoteki (`external_ids_chron_encje`, migracja 804; `genesis_connectors_chron_konto`, 805)
 * odmawiają kodem `23001` (`restrict_violation`) z komunikatem, który nazywa system zewnętrzny, i z podpowiedzią,
 * co zrobić zamiast tego (np. wyłączyć kartę zamiast ją usuwać). Ekran pokazuje te słowa; każdy inny błąd —
 * zdanie zapasowe ekranu, bo komunikat techniczny (klucz obcy, uprawnienia) nie jest dla osoby przy panelu.
 *
 * Błąd przychodzi z PostgREST (`{ code, message, hint }`), ale wołający łapie go jako `unknown`.
 */
export function powodOdmowy(blad: unknown, zapas: string): string {
  if (typeof blad !== 'object' || blad === null) return zapas;
  const { code, message, hint } = blad as { code?: unknown; message?: unknown; hint?: unknown };
  if (code !== '23001' || typeof message !== 'string' || message.trim() === '') return zapas;
  return typeof hint === 'string' && hint.trim() !== '' ? `${message} ${hint}` : message;
}
